import { TASKS_API_ENDPOINT } from "@/constants/constant";
import baseApi from "../../baseApi";
import { ApiResponse, ResultType, Task, UseQueryParams } from "./tasks.type";
import { verify } from "crypto";

export const tasksApiSlice = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTasksApiCall: build.query<
      ApiResponse<ResultType<Task>>,
      UseQueryParams | void
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();

        if (params?.campaignId) {
          queryParams.append("campaignId", params?.campaignId);
        }

        return `${TASKS_API_ENDPOINT.GET_TASKS}?${queryParams.toString()}`;
      },
      providesTags: ["Tasks"],
    }),

    createTaskApiCall: build.mutation<ApiResponse<ResultType<Task>>, any>({
      query: (tasksBody) => ({
        url: TASKS_API_ENDPOINT.CREATE_TASK,
        method: "POST",
        body: tasksBody,
      }),
      invalidatesTags: ["Tasks"],
    }),

    updateTaskApiCall: build.mutation<ApiResponse<ResultType<Task>>, any>({
      query: (tasksBody) => ({
        url: TASKS_API_ENDPOINT.UPDATE_TASK,
        method: "PUT",
        body: tasksBody,
      }),
      invalidatesTags: ["Tasks"],
    }),

    changeCampaignsTaskStatusApiCall: build.mutation<ApiResponse, any>({
      query: (campaignsBody) => ({
        url: `${TASKS_API_ENDPOINT.CHANGE_TASK_STATUS}?taskId=${campaignsBody.taskId}&status=${campaignsBody.status}`,
        method: "PUT",
      }),
      invalidatesTags: ["Tasks"],
    }),

    verifyTaskApiCall: build.mutation<ApiResponse, any>({
      query: (campaignsBody) => {
        const queryParams = new URLSearchParams();
        if (campaignsBody.taskUrl)
          queryParams.append("taskUrl", campaignsBody.taskUrl);
        if (campaignsBody.taskId)
          queryParams.append("taskId", campaignsBody.taskId);

        if (campaignsBody.email)
          queryParams.append("email", campaignsBody.email);
        return {
          url: `${TASKS_API_ENDPOINT.VERIFY_TASK}?${queryParams.toString()}`,
          method: "PUT",
        };
      },
      invalidatesTags: ["Tasks"],
    }),
  }),
});

export const {
  useGetTasksApiCallQuery,
  useUpdateTaskApiCallMutation,
  useCreateTaskApiCallMutation,
  useVerifyTaskApiCallMutation,
  useChangeCampaignsTaskStatusApiCallMutation,
} = tasksApiSlice;

export default tasksApiSlice;
